import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
  MARGIN,
  SIZE,
} from "constants/variables";
import styled from "styled-components";
import cursorIcon from "assets/img/Cursor.png";

export const InstitutionsContactContainer = styled.div`
  padding-block: calc(100px + ${SIZE.max80}) 0;
`;

export const TitleSectionWrapper = styled.div`
  padding-inline: ${SIZE.max220};

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding-inline: ${SIZE.max24};
  }
`;

export const HeaderSectionWrapper = styled.div`
  padding-inline: ${SIZE.max220};
  padding-block: 0 ${SIZE.max40};

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding-inline: 0;
  }
`;

export const ContentSectionWrapper = styled.div`
  padding-inline: ${SIZE.max220};

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding-inline: ${SIZE.max24};
  }
`;

export const BackToWrapper = styled.div<{ biggerCursor?: boolean }>`
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  width: fit-content;
  transition: 0.3s ease-out;
  :hover {
    filter: brightness(0.7);
  }
`;

export const BackToGuidesImage = styled.img`
  margin-right: 8px;
  svg {
    width: 10px;
    height: 16px;
  }
  transform: rotate(90deg);
`;

export const BackToGuidesButton = styled.button`
  background-color: transparent;
  border: none;
  margin-bottom: ${MARGIN.max6};
  cursor: pointer;
`;

export const TitleWrapper = styled.div`
  margin-top: 8px;
  margin-bottom: 24px;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;

export const ContactCardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SIZE.max24};
  padding-block: 0 ${SIZE.max40};
`;

export const ContactCardWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${COLORS.Cultured};
  border-radius: ${BORDER_RADIUS.radius24};
  padding: ${SIZE.max32};
  display: flex;
  flex-direction: column;
`;

export const ContactCardTitleWrapper = styled.div``;

export const ContactCardContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: ${SIZE.max160};

  @media (max-width: 1500px) {
    column-gap: ${SIZE.max80};
  }

  @media (max-width: 1280px) {
    flex-direction: column;
    row-gap: ${SIZE.max16};
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  word-break: break-word;
  overflow-wrap: break-word;
  min-width: 150px;
`;

export const ColumnNoBreak = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NoDataContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  padding: ${SIZE.max32};
`;

export const SvgContainer = styled.div`
  height: auto;
  width: auto;
  margin-bottom: ${MARGIN.max32};
  opacity: 0.4;
  > svg {
    height: ${SIZE.max400};
    width: ${SIZE.max400};
  }
`;
